<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'App'
}
</script>
<style lang="scss">
body {
    font-family: Helvetica Neue, Helvetica, Arial, PingFang SC, Hiragino Sans GB, WenQuanYi Micro Hei, Microsoft Yahei, sans-serif;
    color: #515a6e;
    background-color: #fff;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale
}

/*滚动条样式开始*/

/* 火狐美化滚动条 */
* {
    scrollbar-color: #d5d5d5 #ffffff;
    /* 滑块颜色  滚动条背景颜色 */
    scrollbar-width: thin;
    /* 滚动条宽度有三种：thin、auto、none */
}

::-webkit-scrollbar {
    width: 5px; /* 纵向滚动条*/
    height: 5px; /* 横向滚动条 */
    background-color: #fff;
}

::-webkit-scrollbar-button {
    display: none;
}

/*定义滚动条轨道 内阴影*/
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    background-color: #fff;
}

/*定义滑块 内阴影*/
::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    background-color: #d5d5d5;
}

/*滚动条样式结束*/

.page_err {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: url("./assets/error/bg.jpg") no-repeat;
    background-size: cover;
    color: #fff;
    font-size: 16px;
    text-align: justify;
    padding-left: 10%;

    h1 {
        letter-spacing: 10px;
        font-weight: lighter;
        font-size: 10em;
        margin: 10% 0 3% 0;
    }

    .msg {
        font-size: 2em;
        letter-spacing: 3px;
    }

    .tips {
        color: #909399;
        margin-top: 2em;
    }

    .mybtn {
        font-size: 1em;
        margin-top: 2em;
    }
}

.page-container {
    width: 100%;
    min-height: 100%;
    overflow-y: auto;
    padding: 20px;
    background-color: #f8faff;
}

.p20 {
    padding: 20px;
}

.p40 {
    padding: 40px;
}

.px20 {
    padding-left: 20px;
    padding-right: 20px;
}

.mb30 {
    margin-bottom: 30px;
}

.fontsize20 {
    font-size: 20px;
}

.bold {
    font-weight: bold;
}

.text_danger {
    color: #F56C6C;
}

.text_primary {
    color: #409EFF;
}

.text_info {
    color: #909399;
}

.text_warning {
    color: #E6A23C;
}

.text_success {
    color: #67C23A;
}

.template_list_wrap .image-slot {
    margin: 0 auto;
}

.image-slot {
    text-align: center;
}

.image-slot > i {
    font-size: 28px;
}


.el-avatar > img {
    margin: 0 auto;
}

input[type=number] {
    -moz-appearance: textfield;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* 去掉模板编辑的边框开始 */
.vdr {
    border: 1px dashed transparent !important;
}

/* 去掉模板编辑的边框结束 */

/*全屏遮罩开始*/
.zz {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.2);
}

.el-image-viewer__mask {
    background-color: #fff;
    opacity: 1;
}

/*全屏遮罩结束*/


/* card 自定义样式开始 */
.myheader {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.card-left {
    padding-left: 10px;
    border-left: 5px solid #409EFF;
    height: 28px;
    line-height: 28px;
}

.ec_box {
    margin-bottom: 30px;
}

.ec_wrap {
    height: 300px;
    width: 100%;
}

.myechcart {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow: hidden;
}


.metting_create .el-card__body {
    padding-bottom: 16px;
}

/* card 自定义样式结束 */


/* 日历开始 */
.el-calendar__header {
    display: none;
}

.el-calendar__body {
    padding: 0;
}

.el-calendar-day {
    height: 140px !important;
    overflow-y: auto;
}

.el-calendar-table thead {
    background-color: #f8faff;
}

.el-calendar-table thead th {
    color: #106fff;
}

.el-calendar-table thead th::before {
    content: '周';
}

.metting_ceil {
    background-color: #f0f2f7;
    color: #4d648f;
    margin: 0 0 8px 0;
    padding: 8px 12px;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis; /* 加省略号 */
    white-space: nowrap; /* 强制不换行 */
}


.el-calendar-table td.is-selected {
    background-color: transparent;
}

.top1 {
    width: 100%;
    height: 72px;
    margin-bottom: 15px;

    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    align-items: center;
}

/* 日历结束 */


/* 时间戳开始*/
.p10_card .el-card__body {
    padding: 10px;
}

.el-timeline-item__content {
    margin-top: 5px;
}

/* 时间戳结束 */


/* 右键菜单开始 */
.contextMenu {
    position: fixed;
    margin: 0;
    background: #fff;
    z-index: 3000;
    list-style: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #303133;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
}

.contextMenu li {
    margin: 0;
    padding: 10px 50px 10px 20px;
    cursor: pointer;
}

.contextMenu li:hover {
    background-color: #409EFF;
    color: white;
}

/* 右键菜单结束 */


.mytablerow {
    height: 80px;
    font-size: 18px;
}

.mytablerow td:first-child {
    padding-left: 20px;
}

.mytablerow td:last-child {
    padding-right: 20px;
}


/* upload */
.upload-avatar {
    .el-upload-dragger {
        width: 120px;
        height: 120px;

        display: flex;
        justify-content: center;
        align-items: center;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }

    .avatar {
        max-width: 120px;
        max-height: 120px;
        display: block;
        margin: 0 auto;
    }
}

/* upload end */


.my_default {
    width: 100%;
    height: 100%;
    position: absolute;
    font-size: 48px;
    line-height: 1.4;
    color: rgba(0, 0, 0, 1);
    letter-spacing: 0;
    cursor: default;
}


.door_access {
    .con {
        display: flex;
        flex-direction: row;
        //justify-content: space-around;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding-top: 20px;
    }

    .item {
        border-radius: 5px;
        margin: 0 40px 40px 0;
    }

    .item-wrap {
        width: 360px;
        height: 360px;
        overflow: hidden;
        background-color: #f8faff;
        position: relative;
        cursor: pointer;
    }

    .dsc {
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        height: 32px;
        line-height: 32px;
        margin-top: 10px;
        padding-left: 3px;
    }

    .action {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        height: 100%;
        background-color: rgba(192, 196, 204, 0.9);
        position: absolute;
        left: 0;
        top: -100%;
    }

    .item-wrap:hover > .action {
        top: 0;
    }
}


.custom_page {
    .top {
        padding: 10px 0;
    }

    .con {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding-top: 20px;
    }

    .item {
        border-radius: 5px;
        margin: 0 40px 30px 0;
    }

    .item-wrap {
        width: 360px;
        height: 360px;
        overflow: hidden;
        background-color: #f8faff;
        position: relative;
        cursor: pointer;
    }

    .dsc {
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        height: 32px;
        line-height: 32px;
        margin-top: 10px;
        padding-left: 3px;
    }

    .action {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        height: 100%;
        background-color: rgba(192, 196, 204, 0.9);
        position: absolute;
        left: 0;
        top: -100%;
    }

    .item-wrap:hover > .action {
        top: 0;
    }

    .template_list_wrap {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
    }

    /*上传样式*/
    .chooseTemplate {
        width: 300px;
        height: 300px;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        overflow: hidden;
        position: relative;

    }

    .chooseTemplate:hover {
        border-color: #409EFF;
    }

    .chooseTemplateIcon {
        font-size: 48px;
        color: #8c939d;
        width: 300px;
        height: 300px;
        line-height: 300px;
        text-align: center;
    }


    .template_item {
        background-color: #f0f2f7;
        width: 275px;
        height: 325px;
        margin: 10px 15px;
        padding: 0;
        border: 1px solid transparent;
    }

    .template_item_active {
        border: 1px solid #409EFF;
    }
}


.template_edit_page {
    .header {
        width: 100%;
        height: 80px;
        border: 1px solid #F2F6FC;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
    }

    .d1, .d2, .d3 {
        height: 100%;

        display: flex;
        align-items: center;
    }

    .mydropdown {
        user-select: none;
        width: 90px;
        height: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
        cursor: pointer;
        flex-direction: column
    }

    .mydropdown:hover {
        background-color: #409EFF;
        color: #fff;
    }

    .dropdown_active {
        background-color: #409EFF;
        color: #fff;
    }

    .con {
        height: calc(100% - 80px);
        width: 100%;

        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        justify-content: space-between;
    }

    .c_box {
        height: 100%;
        overflow: scroll;
    }

    .box2 {
        width: calc(100% - 350px);
        background-image: linear-gradient(45deg, #f5f5f5 25%, transparent 0, transparent 75%, #f5f5f5 0), linear-gradient(45deg, #f5f5f5 25%, transparent 0, transparent 75%, #f5f5f5 0);
        background-position: 0 0, 13px 13px;
        background-size: 26px 26px;
        background-color: #f8faff;
        position: relative;
        box-sizing: border-box;
    }

    .box3 {
        background-color: #fff;
        padding: 20px 10px;
        width: 350px;
    }

    .draggable.resizable.vdr {
        max-height: 100%;
        max-width: 100%;
    }



    .hb_wrap {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }

    .hb {
        background-color: #fff;
        border: none;
        box-sizing: border-box;
        position: absolute;
        top: 50%;
        left: 50%;
        padding: 0;
        margin: 0;
    }

    .box3 {
        width: 350px;
        background-color: #fff;
    }

    .left_box_active {
        border-color: #106fff !important;
    }

    .left_box {
        border: 1px solid transparent;
        background-color: rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: nowrap;
        padding: 15px 10px;
        margin-bottom: 30px;
        cursor: pointer;
    }

    .left_box:hover {
        border-color: #106fff;
    }

    .left_box img {
        width: 100%;
        height: 100%;
    }

    .item-input {
        width: 52px;
        height: 28px;
        background: #f8faff;
        border: 1px solid #f0f2f7;
        border-radius: 4px;
        text-align: center;
        line-height: 28px;
        outline: none;
    }
}

.template_system_page {
    .top {
        padding: 10px 0;
    }

    .con {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding-top: 20px;
    }

    .item {
        border-radius: 5px;
        margin: 0 40px 30px 0;
        width: 360px;
    }

    .item-wrap {
        width: 360px;
        height: 360px;
        overflow: hidden;
        background-color: #f8faff;
        position: relative;
        cursor: pointer;
    }

    .dsc {
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        height: 32px;
        line-height: 32px;
        margin-top: 10px;
        padding-left: 3px;
    }

    .action {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        height: 100%;
        background-color: rgba(192, 196, 204, 0.9);
        position: absolute;
        left: 0;
        top: -100%;
    }

    .item-wrap:hover > .action {
        top: 0;
    }
}

.user_min_item {
    width: 100%;

    .el-form-item {
        width: 175px;
    }
}
</style>
